import { useEffect } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { useDemoOpenStore } from "@/stores/demo-open-store";

export function DemoOpenOverlay() {
  const { t } = useTranslation();
  const mounted = useDemoOpenStore((s) => s.mounted);
  const phase = useDemoOpenStore((s) => s.phase);

  useEffect(() => {
    if (!mounted) return;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mounted]);

  if (!mounted) return null;

  const exiting = phase === "exit";

  return createPortal(
    <div
      className={`demo-open-overlay${exiting ? " demo-open-overlay--exit" : ""}`}
      role="status"
      aria-live="polite"
      aria-busy={!exiting}
    >
      <div className="demo-open-overlay__veil" aria-hidden />
      <div
        className={`demo-open-overlay__panel${exiting ? " demo-open-overlay__panel--exit" : ""}`}
      >
        <span className="demo-open-overlay__mark" aria-hidden>
          ✦
        </span>
        <p className="demo-open-overlay__eyebrow">{t("demo.openingEyebrow")}</p>
        <h2 className="demo-open-overlay__title">{t("demo.openingTitle")}</h2>
        <p className="demo-open-overlay__hint">{t("demo.openingHint")}</p>
        <div className="demo-open-overlay__progress" aria-hidden>
          <span className="demo-open-overlay__progress-dot" />
          <span className="demo-open-overlay__progress-dot demo-open-overlay__progress-dot--2" />
          <span className="demo-open-overlay__progress-dot demo-open-overlay__progress-dot--3" />
        </div>
      </div>
    </div>,
    document.body,
  );
}
